import React, { useMemo, useState, useCallback, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import style from "./index.module.scss"
import SignLayout from 'layouts/sign-layout/SignLayout'
import Input from 'components/input'
import { useInput } from 'hooks/useInput'
import { Link, useHistory } from 'react-router-dom'
import { RouterPaths, OK } from 'utils/constant'
import Button from 'components/button'
import Icon from 'components/Icon/Icon'
import classnames from "classnames"
import Model from 'components/model'
import Card from 'components/card/Card'
import { $login, $signupPhone, qrLogin } from 'service/sign'
import { Area } from 'types/interface'
import { getStorage } from 'utils/localstorage'
import { filter } from 'utils/filter'
import { useSendMessage } from 'hooks/useSendMessage'
import { useSign } from 'hooks/useSign'
import { getSearch, resetVerify, checkCaptcha } from 'utils/utils'
import ModelFn from 'components/model/ModelFn'
import { useErrorHint } from 'hooks/useErrorHint'
import { useValidate } from 'hooks/useValidate'
import NewModal from "components/model/newModal"
import BackHomePage from "components/model/backHomePage"
import Verify from "components/verify/index"
import { redirectUrl } from "utils/router"

interface CRef {
  onSubmit: () => void
}

const SignInPhone: React.FC = () => {
  const [phone, setPhone] = useInput('')
  const [phoneHint, setPhoneHint] = useState('')
  const [passwd, setPasswd] = useInput('')
  const [passwdHint, setPasswdHint] = useState('')
  const [areaCode, setAreaCode] = useState<Area | null>(null)
  const [remember, setRemember] = useState(true)
  const [loading, setLoading] = useState(false)
  const [otherLogin, setOtherLogin] = useState(false)
  const [reset,setreset] = useState(false)
  const [showVerify, setShowVerify] = useState(false)
  const [show, setshow] = useState({ modal: false, text: '' })
  const [backModalShow, setbackModalShow] = useState({ modal: false, text: '' })
  const [isVerify,setisVerify] = useState(false)


  const cRef = useRef<CRef>(null)


  const history = useHistory()
  const rememberKey = 'phone-acount'
  const qrid = getSearch('qr')
  const redirect = getSearch('redirect')

  const errHint = useErrorHint()

  const validate = useValidate([
    {
      key: "手机",
      value: phone,
      setHint: setPhoneHint,
      isNum: true
    },
    {
      key: "密码",
      value: passwd,
      setHint: setPasswdHint
    },
  ])


  const $request: any = useCallback(() => {
    if (checkCaptcha()) {
      return {
        status: 'fail',
        code: 20011,
      }
    }
    return $login({
      test: window['getNVCVal'] ? window['getNVCVal']() : null,
      auth: 'mobile',
      phone,
      cc: (areaCode as Area).calling_code,
      password: passwd,
      qr: qrid,
    })
  }, [areaCode, passwd, phone, qrid])

  const successQrLogin = useCallback(() => {
    return setTimeout(async () => {
      if (qrid) {
        setLoading(true)
        try {
          const data = await qrLogin(qrid)
          if (data.status === OK) {
            ModelFn.confirm({
              text: '扫码登录成功',
              noCancel: true,
              onConfirm: () => {
                setShowVerify(false)
                history.push(RouterPaths.userInfo)
              }
            })
          } else {
            errHint(filter(data.code, data.error), '扫码登录失败')
          }
        } catch (error) {
          errHint('网络错误', '扫码登录失败')
        }
        setLoading(false)
      } else {
        if (redirect) {
          redirectUrl(redirect)
          return
        }
        history.push(RouterPaths.home)
      }
    }, 50)
  }, [history, qrid, errHint, redirect])

  const successQrSigup = useCallback(() => {
    return setTimeout(async () => {
      if (qrid) {
        setLoading(true)
        try {
          const data = await qrLogin(qrid)
          if (data.status === OK) {
            ModelFn.confirm({
              text: '扫码登录成功',
              noCancel: true,
              onConfirm: () => {
                setShowVerify(false)
                history.push(RouterPaths.userInfo)
              }
            })
          } else {
            errHint(filter(data.code, data.error), '扫码登录失败')
          }
        } catch (error) {
          errHint('网络错误', '扫码登录失败')
        }
        setLoading(false)
      } else {
        if (redirect) {
          redirectUrl(redirect)
          return
        }
        setbackModalShow({ modal: true, text: '' })


      }
    }, 50)
  }, [history, qrid, errHint, redirect])

  const rememberObj = useMemo(() => ({
    phone,
    passwd,
    area: areaCode
  }), [phone, passwd, areaCode])

  const noSignup = useCallback(() => {
    setShowVerify(true)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //重置验证组件
  const resetComponent = () => {
    resetVerify(setreset)
  }


  const onLogined = useSign({ loading, setLoading, validate, $request, successFn: successQrLogin, setHint: setshow, remember, rememberKey, rememberObj, noSignup ,resetComponent})

  const handleOtherLogin = useCallback(() => {
    history.push(`${RouterPaths["signin-email"]}${window.location.search}`)
  }, [history])


  if (!show.modal && !showVerify) {
    //如果弹窗未展示出来则将enter绑定到登录上
    document.onkeydown = function (e) {
      if (e.key === 'Enter') {
        onLogined()
      }
    }
  } else if (show.modal) {
    document.onkeydown = function (e) {
      //如果弹窗展示出来了之后则将enter绑定到弹窗上
      if (e.key === 'Enter') {
        setshow({ text: '', modal: false })
      }
    }
  } else if (!show.modal && showVerify) {
    document.onkeydown = function (e) {
      //如果弹窗展示出来了之后则将enter绑定到弹窗上
      if (e.key === 'Enter') {
        // VerifyPhone.onSubmit()
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        if (cRef.current) {
          cRef.current.onSubmit()
        }
      }
    }
  }

  useEffect(() => {
    const account = getStorage(rememberKey)
    account && account.phone ? setisVerify(true) : setisVerify(false)
    if (account) {
      if (!phone && !passwd) {
        setPhone(account.phone)
        setPasswd(account.passwd)
        setAreaCode(account.area)
      }
    }
    // console.log('TV扫码跳转的', window.location.href.includes('source=tv'))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // const onRef=()=>{}

  return useMemo(() => (
    <SignLayout>
      <div className={style['signin-phone']}>
        <div className={style.title}>登录/注册</div>
        <div className={style.hint}>
          <div>请使用手机号和密码登录，如未登录过，首次登录将自动注册，请确保输入正确的密码。</div>
          <div style={{ marginTop: '10px' }}>中国大陆手机如在国外漫游使用，国家码请选择“中国+86”。</div>
        </div>
        <div className={style.form}>
          <div className={style['form-label']}>
            <Input
              value={phone}
              onChange={(phone) => { setPhone(phone);setisVerify(true) }}
              onFocus={() => setPhoneHint('')}
              hint={phoneHint}
              placeholder="请输入手机号"
              isPhone={true}
              selectCode={setAreaCode}
            />
          </div>
          <label className={style['form-label']}>
            <Input
              value={passwd}
              onChange={setPasswd}
              onFocus={() => setPasswdHint('')}
              type='password'
              hint={passwdHint}
              placeholder="请输入密码"
            />
          </label>
          <label className={style['form-label'] + ' ' + style['form-label2']}>
            <div>
              <input
                type="checkbox"
                defaultChecked={remember}
                onChange={() => setRemember(!remember)}
              ></input>
              <span className={style.remember + ' no-selector'}>记住密码</span>
            </div>
            <Link to={location => ({ ...location, pathname: RouterPaths["forget-phone"] })} >
              <span className={style['forget-btn']}>忘记密码?</span>
            </Link>
            <NewModal
              show={show.modal}
              text={show.text}
              onCancel={() => setshow({ text: '', modal: false })}
              onConfirm={() => setshow({ text: '', modal: false })}
            />
            <BackHomePage
              show={backModalShow.modal}
              title={'您已成功注册穿梭账号'}
              text={'我们已赠送您3天会员时长，赶紧试试吧'}
              onCancel={() => setbackModalShow({ text: '', modal: false })}
              onConfirm={() => { history.push(RouterPaths.home); setbackModalShow({ text: '', modal: false }) }}
              account={() => { history.push(RouterPaths.userInfo) }}
            />

          </label>
          {
            showVerify || !isVerify
              ? null
              : (
                // <div id="captcha"></div>
                <Verify reset={reset} style2={{marginTop:20}} />
              )
          }
          <div className={style.submit}>
            <Button
              onClick={onLogined}
              className={style.button}
              title='登录'
              type="green"
              loading={loading}
            />
            <div
              onClick={() => setOtherLogin(!otherLogin)}
              className={style['use-other']}>
              使用其它方式登录
              <Icon icon="iconicon_unfold" className={classnames(style.icon, {
                rotate180: otherLogin
              })} />
            </div>
          </div>
          <div className={classnames(style['other-login'], {
            [style.active]: otherLogin
          })}>
            <Button
              title="邮箱账号密码登录"
              type="gray"
              className={style.button}
              onClick={handleOtherLogin}
            />
          </div>
        </div>
        {
          showVerify
            ? (
              <VerifyPhone
                area={(areaCode as Area)}
                passwd={passwd}
                phone={phone}
                show={showVerify}
                onHide={() => setShowVerify(false)}
                onQrLogin={successQrSigup}
                ref={cRef}
                setshowModal={setshow}
                setBackModal={setbackModalShow}
              />
            )
            : null
        }
      </div>
    </SignLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [phone, phoneHint, setPhone, passwd, passwdHint, setPasswd, remember, setRemember, loading, onLogined, otherLogin, showVerify, areaCode, handleOtherLogin, successQrLogin])
}

interface VerifyPhoneProps {
  ref?: any;
  phone: string
  passwd: string
  area: Area
  show: boolean
  onHide: () => any
  onQrLogin: () => any
  setshowModal?: any;
  setBackModal?: any;
}

interface CRef {
  onSubmit: () => void
}

const VerifyPhone = forwardRef<CRef, VerifyPhoneProps>(({ phone, show, onHide, area, passwd, onQrLogin, setshowModal, setBackModal }, ref) => {
  const [code, setCode] = useInput('')
  const [codeHint, setCodeHint] = useState('')
  const [startTime, setStartTime] = useState(false)
  const [loading, setLoading] = useState(false)
  const [canSend, setCanSend] = useState(true)
  const [reset,setreset] = useState(false)
  const qrid = getSearch('qr')

  const setModal = (text) => {
    setshowModal({ modal: true, text })
  }
  // const errHint = useErrorHint()
  //重置验证组件
  const resetComponent = (flag?: boolean) => {
    if(flag){
      resetVerify(setreset)
    // eslint-disable-next-line no-empty
    }else{
      
    }

  }



  const onSendMessage = useSendMessage(startTime, setStartTime, canSend, setCanSend, area, phone, setModal, 'login', 'phone', undefined, resetComponent)

  const onTimeend = useCallback(() => {
    setStartTime(false)
  }, [])

  const validate = useCallback(() => {
    if (code) return true
    if (!code) {
      setCodeHint('请输入短信验证码')
    }
    return false
  }, [code])

  const $request = useCallback(() => {
    if (checkCaptcha()) {
      return {
        status: 'fail',
        code: 20011,
      }
    }
    return $signupPhone({
      test: window['getNVCVal'](),
      phone,
      cc: area.calling_code,
      password: passwd,
      sms_code: code,
      qr: qrid,
    })
  }, [phone, area.calling_code, passwd, code, qrid])

  const successFn = useCallback(() => {
    // return setTimeout(() => {
    //   history.push(RouterPaths.home)
    // }, 50)
    onQrLogin()

  }, [onQrLogin])

  const onSubmit = useSign({ loading, setLoading, validate, $request, successFn, setHint: setshowModal,remember : false, rememberKey : '', rememberObj : {}, noSignup : ()=>{}, resetComponent })
  useImperativeHandle(ref, () => ({
    onSubmit
  }))
  return useMemo(() => (
    <Model
      show={show}
      onHide={onHide}
    >
      <div className={style['verify-phone']}>
        <div className={style.title}>登录</div>
        <div className={style.hint}>
          首次登录请使用您的手机进行验证
        </div>
        <Card
          className={style.card}
          text={`手机号：${area.calling_code} ${phone}`} />
        <div className={style.form}>
          <div className={style.hint} style={{ marginBottom:10 }}>
           完成滑动验证后请点击“获取短信验证码”
          </div>
          <Verify reset={reset} />
          <div className={style['form-label']}>
            <Input
              value={code}
              onChange={setCode}
              onFocus={() => setCodeHint('')}
              hint={codeHint}
              placeholder="请输入手机验证码"
              isMessage={true}
              onSendMessage={onSendMessage}
              startTime={startTime}
              onTimeend={onTimeend}
              canSendMessage={canSend}
            />
          </div>
          {/* <div id="captcha"></div> */}
          <div className={style.submit}>
            <Button
              onClick={onSubmit}
              className={style.button}
              title='确定'
              type="green"
              loading={loading}
            />
          </div>
        </div>
      </div>

    </Model>
  ), [show, onHide, code, setCode, codeHint, setCodeHint, onSendMessage, startTime, onTimeend, onSubmit, loading, area.calling_code, phone, canSend, reset])
})

export default SignInPhone
